
Dropzone = require('dropzone');

window.initDropzone = function() {

	var dropzoneSelector = "#contactDropzone";

	if ($(dropzoneSelector).length > 0) {
		myDropzone = new Dropzone(dropzoneSelector, {
			url: "/ajax/contact/magasin/pj",
			maxFilesize: 2, //MB
			uploadMultiple: false,
			paramName: "documents",
			maxThumbnailFilesize: 2, //MB
			headers: {
				'x-csrf-token': $('meta[name="csrf-token"]').attr('content')
			},
			maxFiles: 10,
			parallelUploads: 1,
			addRemoveLinks: true,
			dictFileTooBig: Lang._i('contact.pj.toobig'),
			dictInvalidFileType: Lang._i('contact.pj.invalidfiletype'),
			dictRemoveFile: '<i class="material-icons">delete_forever</i>',
			dictCancelUpload: '<i class="material-icons">delete_forever</i>',
			dictMaxFilesExceeded: Lang._i('contact.pj.maxfilexceeded'),
			hiddenInputContainer: $(dropzoneSelector).parents('form').get(0),
			success: function (response, b) {
				//console.log( b.filename );
				//ajout du champ contenant le lien du doc
				$(response.previewElement).append("<input type='hidden' value='" + b.filepath + "' name='links[" + b.filename + "]' />")
				$(response.previewElement).addClass('dz-upload-success');
			},
			sending: function(){
				$('#contactMagasin [type=submit]').attr('disabled', 'disabled');
			},
			complete: function(){
				$('#contactMagasin [type=submit]').removeAttr('disabled');
			}

		});
	}
}

// CONTACT MAGASIN
$('body').on('submit','#contactMagasin', function (e) {

	e.preventDefault();
	if ( typeof myDropzone != 'undefined') {	//au cas où.
		myDropzone.processQueue();
	}

	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});

	$.ajax({
			type: 'POST',
			url: $(this).attr('action'),
			data: $(this).serialize(),
			dataType: 'json'
		})
		.done(function (data) {

			var modal = $('#modal-contact');
			cleanModal(modal);


			if (data.result > 0) {

				modal.find('.feedback-contact').text(Lang._i('contact-magasin.alert.success')).addClass('alert-success').removeClass('alert-danger d-none');
				$('#contactMagasin')[0].reset();
				if ( typeof myDropzone != 'undefined') {	//au cas où.
					myDropzone.removeAllFiles();
				}
			} else if (data.result < 0) {

				modal.find('.feedback-contact').text(Lang._i('contact-magasin.alert.error')).addClass('alert-danger').removeClass('alert-success d-none');
			} else {

				$.each(data.errors, function (key, value) {

					modal.find('input[name=' + key + ']').addClass('is-invalid').after('<div class="invalid-feedback">' + value + '</div>');
				});
			}
		})
		.fail(function (jqXHR, textStatus, errorThrown) {

			//console.log('Contact magasin', errorThrown);
		});

	return false;

});

$('#modal-contact').on('hidden.bs.modal', function (e) {

	cleanModal($(this));
	if ( typeof myDropzone != 'undefined') {	//au cas où.
		myDropzone.removeAllFiles();
	}
	$('#contactMagasin')[0].reset();
});

// Reset modal Contact Magasin
$('#modal-contact').on('shown.bs.modal', function (e) {

	var obj = '';

	if (e.relatedTarget.nodeName == 'A' && e.relatedTarget.href != '') {

		// on vient de la page rch
		var str = e.relatedTarget.href;

		// Dans ce cas, on passe l'objet en JS
		var obj = e.relatedTarget.dataset.objet;
	} else if (e.relatedTarget.nodeName == 'BUTTON' && $(e.relatedTarget).data('email') != '') {
		// button avec data-mail (Page vide maison)
		var str = $(e.relatedTarget).data('email');
	} else {

		// on vient de la page produit
		var str = $('a[href^="mailto:"].js-mail-magasin').first().attr('href');
	}

	var res = str.replace('mailto:', '');
	$('input#to').val(res);

	// si sur liste
	if ($('input#objet').length > 0 && obj.length > 0 && $('#js-result-search').length > 0) {

		$('input#objet').val(obj);
	}
	initDropzone();
});
